import React from 'react';
import {
    Segment,
    Button,
    Divider,
    Icon,
    Form,
    Input,
    Grid,
    Loader
} from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { toast, ToastContainer } from 'react-toastify';
import { number } from 'prop-types';
import { DateTimePicker } from 'react-widgets';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class CreateCourseEquivalence extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            disableSemester: true,
            courseOptions: [],
            markOptions: [],
            statusOptions: [{
                value: 'REJECTED',
                key: '0',
                text: 'odbijeno'
            },
            {
                value: 'THIRD',
                key: '1/3',
                text: 'priznata trećina'
            },
            {
                value: 'HALF',
                key: '1/2',
                text: 'priznata polovina'
            },
            {
                value: 'FULL',
                key: '1',
                text: 'priznato'
            }
            ]
        };

        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.createCourseEquivalence = this.createCourseEquivalence.bind(this);
        this.resetForm = this.resetForm.bind(this);
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }
    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        }, () => {
            if (name === 'targetCourseSPId') {
                axios.get(`/study-programs/semesters/by-course-study-program/${value}`).then(response => {
                    this.setState({
                        semesterOptions: response.data.map(el => ({
                            value: el.id,
                            key: el.id,
                            text: el.name
                        })),
                        disableSemester: false
                    });
                });
            }
        });
    }


    componentDidMount() {
        let candidateId = localStorage.getItem('candidateId');
        axios.get(`/equivalence/${candidateId}/courses/available-course-study-programs`).then(response => {
            this.setState({
                courseOptions: response.data.map(el => ({
                    value: el.courseStudyProgramId,
                    key: el.courseStudyProgramId,
                    text: el.courseStudyProgramName
                }))
            });
        });

        axios.get('/marks').then(response => {
            this.setState({
                markOptions: response.data.map(el => ({
                    value: {id: el.id, el: { ...el }},
                    key: el.id,
                    text: el.displayName
                }))
            });
        });
    }
    resetForm() {
        this.setState({
            originalCourseName: '',
            ects: '',
            targetCourseSPId: null,
            mark: null,
            semester: null,
            status: null
        });
    }
    createCourseEquivalence() {
        if (!this.state.originalCourseName || !this.state.ects || !this.state.targetCourseSPId || !this.state.mark || !this.state.semester || !this.state.status || !this.state.date) {
            toast(<FormattedMessage id="common.requiredFields" />);
            if (!this.state.originalCourseName) { this.setState({ originalCourseNameErr: true }); } else { this.setState({ originalCourseNameErr: false }); }
            if (!this.state.ects) { this.setState({ ectsErr: true }); } else { this.setState({ ectsErr: false }); }
            if (!this.state.targetCourseSPId) { this.setState({ targetCourseSPIdErr: true }); } else { this.setState({ targetCourseSPIdErr: false }); }
            if (!this.state.mark) { this.setState({ markErr: true }); } else { this.setState({ markErr: false }); }
            if (!this.state.semester) { this.setState({ semesterErr: true }); } else { this.setState({ semesterErr: false }); }
            if (!this.state.status) { this.setState({ statusErr: true }); } else { this.setState({ statusErr: false }); }
            if (!this.state.date) { this.setState({ dateErr: true }); } else { this.setState({ dateErr: false }); }
        } else {
            this.setState({ disableButton: true });
            let candidateId = localStorage.getItem('candidateId');
            let obj = {
                targetCourseStudyProgramId: this.state.targetCourseSPId,
                targetMarkId: this.state.mark.id,
                courseEquivalenceStatus: this.state.status,
                sourceCourseName: this.state.originalCourseName,
                targetLkpStudyProgramSemesterId: this.state.semester,
                sourceCourseEcts: parseFloat(this.state.ects),
                targetDate: new Date(),
                sourceDate: this.state.date,

            };
            axios.post(`/equivalence/${candidateId}/courses`, obj)
                .then(res => {
                    this.setState({ disableButton: false });
                    this.resetForm();
                    toast('Uspješno ste izvršili ekvivalenciju predmeta!');
                })
                .catch(err => {
                    this.setState({ disableButton: false });
                    toast('Dodavanje predmeta nije uspjelo!');
                });
        }
    }

    render() {
        return (

            <div>


                <Segment clearing vertical >

                    <Grid columns={2}>
                        <Divider vertical><Icon name="long arrow alternate right" /></Divider>

                        <Grid.Column>

                            <Form>
                                <Segment>
                                    <Form.Group widths="equal">

                                        <Form.Field required error={this.state.originalCourseNameErr}>
                                            <label>
                                                Naziv predmeta
                                            </label>
                                            <input
                                                required
                                                fluid
                                                placeholder="Naziv predmeta"
                                                control={Input}
                                                value={this.state.originalCourseName}
                                                name="originalCourseName"
                                                onChange={(e) => this.setState({ originalCourseName: e.target.value })}
                                            />
                                        </Form.Field>


                                    </Form.Group>
                                    <Form.Group widths="equal">


                                        <Form.Field required error={this.state.ectsErr} type={number}>
                                            <label>
                                                ECTS
                                            </label>
                                            <input
                                                required
                                                type="number"
                                                fluid
                                                placeholder="ECTS"
                                                control={Input}
                                                value={this.state.ects}
                                                name="ects"
                                                onChange={(e) => this.setState({ ects: e.target.value })}
                                            />
                                        </Form.Field>

                                    </Form.Group>
                                </Segment>

                            </Form>

                        </Grid.Column>

                        <Grid.Column>

                            <Form>

                                <Segment>
                                    <Form.Group widths="equal">
                                        <Form.Field
                                            required
                                            error={this.state.targetCourseSPIdErr}
                                        >
                                            <label>
                                                Priznat kao
                                            </label>
                                            <Form.Dropdown
                                                clearable
                                                placeholder="Odaberite predmet"
                                                value={this.state.targetCourseSPId}
                                                onChange={this.handleInputChange}
                                                name="targetCourseSPId"
                                                options={this.state.courseOptions}
                                                search
                                                fluid
                                                selection

                                            />
                                        </Form.Field>

                                        <Form.Field
                                            required
                                            error={this.state.markErr}
                                        >
                                            <label>
                                                Ocjena
                                            </label>
                                            <Form.Dropdown
                                                clearable
                                                placeholder="Odaberite ocjenu"
                                                value={this.state.mark}
                                                onChange={this.handleInputChange}
                                                name="mark"
                                                options={this.state.markOptions.filter((e) => (e.value.el.passed))}
                                                search
                                                fluid
                                                selection

                                            />
                                        </Form.Field>


                                    </Form.Group>
                                    <Form.Group widths="equal">

                                        <Form.Field
                                            required
                                            error={this.state.semesterErr}
                                        >
                                            <label>
                                                Semestar
                                            </label>
                                            <Form.Dropdown
                                                clearable
                                                placeholder="Odaberite semestar"
                                                value={this.state.semester}
                                                onChange={this.handleInputChange}
                                                name="semester"
                                                options={this.state.semesterOptions}
                                                search
                                                fluid
                                                disabled={this.state.disableSemester}
                                                selection

                                            />
                                        </Form.Field>
                                        <Form.Field
                                            required
                                            error={this.state.statusErr}
                                        >
                                            <label>
                                                Status
                                            </label>
                                            <Form.Dropdown
                                                clearable
                                                placeholder="Odaberite status"
                                                value={this.state.status}
                                                onChange={this.handleInputChange}
                                                name="status"
                                                options={this.state.statusOptions}
                                                search
                                                fluid
                                                selection

                                            />
                                        </Form.Field>
                                        <Form.Field
                                            required
                                            error={this.state.dateErr}
                                            control={DateTimePicker}
                                            label="Datum"
                                            format="D. M. YYYY."
                                            defaultValue={this.state.date}
                                            placeholder="Unesite datum"
                                            time={false}
                                            // disabled={this.state.type !== 2}
                                            onChange={this.handleDateChange.bind(null, 'date')}
                                            style={{ borderWidth: '0px' }}
                                        />

                                    </Form.Group>

                                </Segment>
                            </Form>

                        </Grid.Column>

                    </Grid>
                    <Loader active={this.state.disableButton} />
                </Segment>

                <Segment clearing vertical>

                    <Grid columns={2} >
                        <Grid.Column>


                        </Grid.Column>
                        <Grid.Column>
                            <Button basic color="blue" floated="right" disabled={this.state.disableButton} onClick={this.props.closeForm}>Odustani</Button>
                            <Button primary color="blue" floated="right" disabled={this.state.disableButton} onClick={this.createCourseEquivalence}>Dodaj</Button>
                        </Grid.Column>

                    </Grid>

                </Segment>


            </div>


        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamEquivalence/Candidates/CandidatesDetails/AddCourse/CreateCourseEquivalence.js